import { render, staticRenderFns } from "./subscriptionfees.vue?vue&type=template&id=3730bdbc"
import script from "./subscriptionfees.vue?vue&type=script&lang=js"
export * from "./subscriptionfees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports